export const SUPER_WHISPERER_MIN_SECRETS = 5;
export const PASSWORD_MIN_LENGTH = 8;
export const NB_PRODUCTS_INFINITE_SCROLL = 20;
export const NB_PRODUCTS_RESULTS_PAGE = 10;
